/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfiguredActionPermissions } from './configuredActionPermissions';


export interface ConfiguredActionDetailDto { 
    id: string;
    name: string;
    severity: ConfiguredActionDetailDto.SeverityEnum;
    ranking: number;
    tenantId: string;
    permissions: ConfiguredActionPermissions;
}
export namespace ConfiguredActionDetailDto {
    export type SeverityEnum = 'IMMINENT_DANGER' | 'DAMAGE' | 'RECOMMENDATION' | 'NO_ACTION';
    export const SeverityEnum = {
        ImminentDanger: 'IMMINENT_DANGER' as SeverityEnum,
        Damage: 'DAMAGE' as SeverityEnum,
        Recommendation: 'RECOMMENDATION' as SeverityEnum,
        NoAction: 'NO_ACTION' as SeverityEnum
    };
}


